import { Component, OnInit, OnDestroy } from '@angular/core';
import { IoService } from '../../../services/io.service';
import { Subscription } from 'rxjs';
import { GaugeLevels } from '../../../widgets/gaugeLevels';

@Component({
  selector: 'app-dashboard-warehouse-zutaten',
  templateUrl: './dashboard-warehouse-zutaten.component.html',
  styleUrls: ['./dashboard-warehouse-zutaten.component.css']
})
export class DashboardWarehouseZutatenComponent implements OnInit, OnDestroy {
  private subDevicePrepSpsLevels: Subscription;
  private triggerAlive: object;
  private levels: object = {level_coffee: 0, level_chocolat: 0, level_water: 0, level_milk: 0 };
  gaugeLevelState = GaugeLevels.state;
  constructor(private ioService: IoService) { }

  ngOnInit() {
    this.subDevicePrepSpsLevels = this.ioService.getDeviceEvents('prep_sps.levels').subscribe(ev => {
      this.levels = ev;
      this.triggerAlive = {};
      console.log(ev);
    });
  }

  ngOnDestroy() {
    if (this.subDevicePrepSpsLevels) { this.subDevicePrepSpsLevels.unsubscribe(); }
  }
}
